import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { EpisodeMonetizationForm } from "~/components/views/app/episode/monetization-form";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute(
	"/_app/podcasts/$channelUid/episodes/$episodeUid/monetization",
)({
	component: Page,
	async loader({ context, params }) {
		context.queryClient.prefetchQuery(
			context.trpc.jingle.list.queryOptions({
				channelUid: params.channelUid,
			}),
		);
		context.queryClient.prefetchQuery(
			context.trpc.waveform.list.queryOptions({
				episodeUid: params.episodeUid,
			}),
		);
	},
});

function Page() {
	const { channelUid, episodeUid } = Route.useParams();
	const trpc = useTRPC();

	const { data: episode } = useSuspenseQuery(
		trpc.episode.find.queryOptions({
			episodeUid,
		}),
	);

	const { data: jingles } = useQuery(
		trpc.jingle.list.queryOptions({
			channelUid,
		}),
	);

	const { data: adBreaks } = useQuery(
		trpc.waveform.list.queryOptions({
			episodeUid,
		}),
	);

	return (
		<EpisodeMonetizationForm
			episode={episode}
			jingles={jingles}
			adBreaks={adBreaks}
		/>
	);
}
